import {
  CAPABILITY_FAN,
  CAPABILITY_PUBLICATIONS,
  CAPABILITY_SUB_AFFILIATE_NETWORK,
} from "@/constants/capability-constants";

export const SECTION_HOME = "section_home";
export const SECTION_EXPLORE = "section_explore";
export const SECTION_STORIES = "section_stories";
export const SECTION_PUBLICATIONS = "section_publications";
export const SECTION_MONETIZATION = "section_monetization";
export const SECTION_COMMUNITY = "section_community";
export const SECTION_BILLING = "section_billing";
export const SECTION_ONBOARDING = "section_onboarding";
export const SECTION_SHOP = "section_shop";

export const MAIN_NAV_PRIMARY = [
  {
    name: SECTION_HOME,
    label: "Home",
    actionValue: "/",
    icon: "material-symbols:home-outline-rounded",
  },
  {
    name: SECTION_EXPLORE,
    label: "Explore",
    actionValue: "/explore",
    icon: "material-symbols:explore-outline-rounded",
  },
  {
    name: SECTION_PUBLICATIONS,
    label: "My Publications",
    actionValue: "/publication/org/{org_id}",
    requiredCapabilities: [CAPABILITY_PUBLICATIONS],
    requiresCreatorApproval: true,
    icon: "material-symbols:newspaper-outline-rounded",
  },
  {
    name: SECTION_MONETIZATION,
    label: "Monetization",
    actionValue: "/monetization/org/{org_id}",
    requiredCapabilities: [CAPABILITY_SUB_AFFILIATE_NETWORK],
    requiresCreatorApproval: true,
    icon: "material-symbols:monetization-on-outline-rounded",
  },
  {
    name: SECTION_COMMUNITY,
    label: "Community",
    actionValue: "/community",
    requiredCapabilities: [CAPABILITY_FAN],
    icon: "material-symbols:groups-outline-rounded",
  },
  {
    name: SECTION_SHOP,
    label: "Shop",
    actionValue: "/shop",
    icon: "material-symbols:storefront-outline-rounded",
  },
  {
    name: SECTION_STORIES,
    label: "My Stories",
    actionValue: "/stories",
    requiredCapabilities: [CAPABILITY_PUBLICATIONS],
    requiresCreatorApproval: true,
    icon: "material-symbols:auto-stories-outline-rounded",
  },
  {
    name: SECTION_ONBOARDING,
    label: "Become A Creator",
    actionValue: "/{org_id}/apply",
    icon: "material-symbols:person-add-outline-rounded",
  },
];

// //////////////////////
// Main Nav Secondary //
// //////////////////////

export const SECTION_DIGITAL_WALLET = "section_digital_wallet";
export const SECTION_SETTINGS = "section_settings";

export const PAGE_ORG_SETTINGS = "page_org_settings";
export const PAGE_USER_SETTINGS = "page_user_settings";
export const PAGE_CONTACT_US = "page_contact_us";
export const PAGE_HELP = "page_help";
export const PAGE_LOGOUT = "page_logout";
export const PAGE_HOME = "page_home";
export const PAGE_CREATOR_DASHBOARD = "page_creator_dashboard";
export const PAGE_STORIES = "page_stories";
export const PAGE_ORGANIZATION = "page_organization";
export const PAGE_INFLUENCER_PLATFORMS = "page_influencer_platforms";
export const PAGE_USER_ACCOUNT = "page_user_account";
export const PAGE_USER_PUBLICATIONS = "page_user_publications";
export const PAGE_SOCIAL_NETWORKS = "page_social_networks";
export const PAGE_ORG_PROFILE_PAGE = "page_org_profile";
export const PAGE_BILLING_AND_SUBSCRIPTIONS = "page_billing_and_subscriptions";
export const PAGE_DIRECTORY = "page_directory";
export const PAGE_MARKETPLACE = "page_marketplace";
export const PAGE_MY_SERVICES = "page_my_services";
export const PAGE_MY_EXPERTISE = "page_my_expertise";
export const PAGE_COMMUNITY_PUBLICATIONS = "page_community_publications";
export const PAGE_INVITES = "page_invites";
export const PAGE_REFER_AND_EARN = "page_refer_and_earn";

export const PAGE_BEAUTY = "page_beauty";
export const PAGE_DIY = "page_diy";
export const PAGE_CREATE_POST = "page_create_post";
export const PAGE_FASHION = "page_create_post";
export const PAGE_TRAVEL = "page_travel";
export const PAGE_FOOD = "page_food";

export const PAGE_STORIES_SYNDICATION = "page_stories_syndication";
export const PAGE_SYNDICATED_STORY = "page_syndicated_story";
export const PAGE_STORIES_REQUIRES_APPROVAL = "page_stories_requires_approval";

export const PAGE_THEMES = "page_themes";
export const PAGE_THEME_PALETTES = "page_theme_palettes";
export const PAGE_PUBLICATION_DEPLOYMENT_HISTORY =
  "page_publication_deployment_history";
export const PAGE_EXPERTS = "page_experts";
export const PAGE_VIDEO_EDITORS = "page_video_editors";
export const PAGE_SOCIAL_MEDIA_MANAGERS = "page_social_media_managers";
export const PAGE_CONTENT_CREATORS = "page_content_creators";
export const PAGE_GRAPHIC_DESIGNERS = "page_graphic_designers";
export const PAGE_MARKETING_STRATEGISTS = "page_marketing_strategists";

export const PAGE_EXPLORE_STORIES = "page_explore_content";
export const PAGE_EXPLORE_DESTINATIONS = "page_explore_destinations";
export const PAGE_EXPLORE_FEEDS = "page_explore_feeds";


export const SIDE_NAV_EXPLORE = [
  {
    name: PAGE_EXPLORE_STORIES,
    label: "Stories",
    actionValue: "/explore/stories",
    icon: "material-symbols:post-outline-rounded",
  },
  {
    name: PAGE_EXPLORE_DESTINATIONS,
    label: "Publications",
    actionValue: "/explore/destinations",
    icon: "material-symbols:newspaper-rounded",
  },
  {
    name: PAGE_EXPLORE_FEEDS,
    label: "Curated Feeds",
    actionValue: "/explore/feeds",
    icon: "material-symbols:dynamic-feed-rounded",
  },
];

export const MAIN_NAV_SECONDARY = [
  {
    name: PAGE_ORG_SETTINGS,
    label: "Company Settings",
    actionValue: "/settings/org/{org_id}",
  },
  {
    name: PAGE_USER_SETTINGS,
    label: "My User Account",
    actionValue: "/settings/user/{user_id}",
  },
  {
    name: PAGE_ORG_PROFILE_PAGE,
    label: "My Profile",
    actionValue: "/community/org/{org_id}/profile",
  },
  // TODO this is subject to change - hiding for dark deploy, unhide when you want to use it
  {
    name: PAGE_BILLING_AND_SUBSCRIPTIONS,
    label: "Billing & Subscriptions",
    actionValue: "/billing/org/{org_id}/active",
  },
  {
    name: PAGE_CONTACT_US,
    label: "Contact Us",
    actionValue: "https://inspirationco.freshdesk.com/support/tickets/new",
  },
  {
    name: PAGE_HELP,
    label: "Help",
    actionValue: "https://help.bloglovin.com",
  },
  {
    name: PAGE_LOGOUT,
    label: "Logout",
    actionValue: "/logout",
  },
];

// /////////////////////////
// Monetization Side Nav //
// /////////////////////////

export const PAGE_AFFILIATE = "page_affiliate";
export const PAGE_LINK_GENERATOR = "page_link_generator";
export const PAGE_INSPIRATION_NETWORK = "page_inspiration_network";
export const PAGE_DIRECT_NETWORK = "page_direct_network";
export const PAGE_LINKS_REPORT = "page_links_report";
export const PAGE_COLLECTIONS_REPORT = "page_collections_report";
export const PAGE_LINKS_COLLECTIONS = "page_links_collections";
export const PAGE_ACTIONS_REPORT = "page_actions_report";
export const PAGE_JAVASCRIPT_TAG = "page_javascript_tag";
export const PAGE_BROWSER_PLUGIN = "page_browser_plugins";
export const PAGE_SPONSORED_CONTENT = "page_sponsored_content";
export const PAGE_SUBSCRIPTIONS = "page_subscriptions";
export const PAGE_DIGITAL_PRODUCTS = "page_digital_products";
export const PAGE_DISPLAY_ADS = "page_display_ads";
export const PAGE_MONETIZATION_OVERVIEW = "page_monetization_overview";
export const PAGE_MONETIZATION_PUBLICATIONS = "page_monetization_publications";
export const PAGE_MONETIZATION_SUBSCRIPTIONS =
  "page_monetization_subscriptions";
export const PAGE_MONETIZATION_DIGITAL_PRODUCTS =
  "page_monetization_digital_products";
export const PAGE_MONETIZATION_SYNDICATION = "page_monetization_syndication";
export const PAGE_MONETIZATION_SPONSORED_CONTENT =
  "page_monetization_sponsored_content";
export const PAGE_MONETIZATION_DISPLAY_ADS = "page_monetization_display_ads";
export const PAGE_MONETIZATION_MY_BRANDS = "page_monetization_my_brands";

export const SIDE_NAV_MONETIZATION = [
  {
    name: PAGE_MONETIZATION_OVERVIEW,
    label: "Overview",
    actionValue: "/monetization/org/{org_id}/overview",
    icon: "chart-line",
  },
  {
    name: PAGE_MONETIZATION_PUBLICATIONS,
    label: "Publications",
    actionValue: "/monetization/org/{org_id}/publications",
    icon: "newspaper",
  },
  {
    name: PAGE_MONETIZATION_SUBSCRIPTIONS,
    label: "Subscriptions",
    actionValue: "/monetization/org/{org_id}/subscriptions",
    icon: "credit-card",
  },
  {
    name: PAGE_MONETIZATION_DIGITAL_PRODUCTS,
    label: "Digital Products",
    actionValue: "/monetization/org/{org_id}/digital-products",
    icon: "box-open",
  },
  {
    name: PAGE_AFFILIATE,
    label: "Affiliate",
    actionValue: "/monetization/org/{org_id}",
    requiredCapabilities: [CAPABILITY_SUB_AFFILIATE_NETWORK],
    icon: "link",
    subItems: [
      {
        name: PAGE_LINK_GENERATOR,
        label: "Link Generator",
        actionValue: "/monetization/org/{org_id}/link-generator",
        icon: "link-simple",
      },
      {
        name: PAGE_MONETIZATION_MY_BRANDS,
        label: "My Brands",
        actionValue: "/monetization/org/{org_id}/my-brands",
        icon: "store",
      },
      {
        name: PAGE_BROWSER_PLUGIN,
        label: "Browser Plugins",
        actionValue: "/monetization/org/{org_id}/browser-plugins",
        icon: "puzzle-piece",
      },
      {
        name: PAGE_INSPIRATION_NETWORK,
        label: "Inspiration Network",
        actionValue: "/monetization/org/{org_id}/inspiration-network",
        icon: "network-wired",
      },
      {
        name: PAGE_DIRECT_NETWORK,
        label: "Direct Network",
        actionValue: "/monetization/org/{org_id}/direct-network",
        icon: "diagram-project",
      },
      {
        name: PAGE_LINKS_REPORT,
        label: "My Links",
        actionValue: "/monetization/org/{org_id}/links",
        alwaysDisplaySubItem: true,
        icon: "list-check",
        subItems: [],
      },
      {
        name: PAGE_ACTIONS_REPORT,
        label: "Affiliate Sales",
        actionValue: "/monetization/org/{org_id}/actions",
        icon: "chart-pie",
      },
      {
        name: PAGE_JAVASCRIPT_TAG,
        label: "Javascript Tag",
        actionValue: "/monetization/org/{org_id}/js",
        icon: "code",
      },
    ],
  },
  {
    name: PAGE_MONETIZATION_SYNDICATION,
    label: "Syndication",
    actionValue: "/monetization/org/{org_id}/syndication",
    icon: "share-nodes",
  },
  {
    name: PAGE_MONETIZATION_SPONSORED_CONTENT,
    label: "Sponsored Content",
    actionValue: "/monetization/org/{org_id}/sponsored-content",
    icon: "star",
  },
  {
    name: PAGE_MONETIZATION_DISPLAY_ADS,
    label: "Display Ads",
    actionValue: "/monetization/org/{org_id}/display-ads",
    icon: "rectangle-ad",
  },
];

// //////////////////////////////////
// Publication Section Page Names //
// //////////////////////////////////

export const PAGE_PUBLICATION_OVERVIEW = "page_publication_overview";
export const PAGE_COLLABORATOR_PROPOSALS =
  "page_publication_invited_to_collaborate";
export const PAGE_MY_COLLABORATOR_PROPOSALS =
  "page_publication_my_collaborator_proposals";
export const PAGE_PUBLICATION_DAILY_SUBSCRIPTION_REVENUE =
  "page_publication_daily_subscription_revenue";
export const PAGE_MY_PUBLICATIONS = "page_my_publications";
export const PAGE_CREATE_PUBLICATION = "page_create_publication";
export const PAGE_COLLABORATING_PUBLICATIONS =
  "page_collaborating_publications";
export const PAGE_CREATE_DIGITAL_PRODUCT = "page_create_digital_product";
export const PAGE_PUBLICATION_DASHBOARD = "page_publication_dashboard";
export const PAGE_PUBLICATION_BRANDING = "page_publication_branding";
export const PAGE_PUBLICATION_DEPLOYMENT = "page_publication_deployment";
export const PAGE_PUBLICATION_ADVERTISING = "page_publication_advertising";
export const PAGE_PUBLICATION_COURSES = "page_publication_courses";
export const PAGE_PUBLICATION_COURSE = "page_publication_course";
export const PAGE_PUBLICATION_DEPLOYMENT_VERSION_HISTORY =
  "page_publication_deployment_version_history";
export const PAGE_PUBLICATION_FEATURES = "page_publication_features";
export const PAGE_PUBLICATION_PRO_FEATURES = "page_publication_pro_features";
export const PAGE_PUBLICATION_FEATURE_SIGNUP_LOGIN =
  "page_publication_signup_and_login";
export const PAGE_PUBLICATION_FEATURE_SUBSCRIPTIONS =
  "page_publication_subscriptions";
export const PAGE_PUBLICATION_FEATURE_DIGITAL_PRODUCTS =
  "page_publication_digital_products";
export const PAGE_PUBLICATION_FEATURE_SOCIAL_MEDIA =
  "page_publication_social_media";
export const PAGE_PUBLICATION_FEATURE_POST_CREATION =
  "page_publication_post_creation";
export const PAGE_PUBLICATION_COLLABORATORS = "page_publication_collaborators";
export const PAGE_PUBLICATION_SUPPORT = "page_publication_support";
export const PAGE_PUBLICATION_FEATURE_SHOP = "page_publication_shop";
export const PAGE_PUBLICATION_MODERATION = "page_publication_moderation";
export const PAGE_PUBLICATION_CHAT_ROOM = "page_publication_chat_room";
export const PAGE_PUBLICATION_COMMENTS = "page_publication_comments";
export const PAGE_PUBLICATION_NAVIGATION_CONFIG =
  "page_publication_navigation_config";
export const PAGE_PUBLICATION_POSTS = "page_publication_posts";
export const PAGE_PUBLICATION_ANALYTICS = "page_publication_analytics";
export const PAGE_PUBLICATION_TEMPLATES = "page_publication_templates";
export const PAGE_PUBLICATION_DOMAIN_CONFIGURATION =
  "page_publication_domain_configuration";
export const PAGE_MY_ACTIVE_PUBLICATIONS = "page_my_active_publications";
export const PAGE_MY_DRAFT_PUBLICATIONS = "page_my_draft_publications";
export const PAGE_MY_INACTIVE_PUBLICATIONS = "page_my_inactive_publications";
export const PAGE_PUBLICATION_SETTINGS = "page_publication_settings";
export const PAGE_PUBLICATION_DIGITAL_PRODUCTS =
  "page_publication_digital_products";
export const PAGE_PUBLICATION_SUBSCRIPTION_PLANS =
  "page_publication_subscription_plans";
export const PAGE_STORY_EDITOR = "page_story_editor";
export const PAGE_SYNDICATED_STORY_EDITOR = "page_syndicated_story_editor";
export const PAGE_PUBLICATION_FEED_GROUP_LIST = "feed_group_list";
export const PAGE_PUBLICATION_FEED_GROUP = "feed_group";
export const PAGE_PUBLICATION_COLLABORATION_AD_DETAILS =
  "page_publication_collaboration_ad_details";

// //////////////////////////////////
// Community Section Page Names //
// //////////////////////////////////

export const PAGE_COMMUNITY_COMMUNITY = "page_community";
export const PAGE_COMMUNITY_TOPIC = "page_community_topic";
export const PAGE_COMMUNITY_SETTINGS = "page_community_settings";
export const PAGE_COMMUNITY_PUBLICATION_COLLABORATION_ADS =
  "page_community_publication_collaboration_ads";
export const PAGE_NETWORK_OVERVIEW = "page_network_overview";
export const PAGE_PUBLICATION_USER_MANAGEMENT = "page_user_management";
export const PAGE_PUBLICATION_USER_ENGAGEMENT = "page_user_engagement";
export const PAGE_PUBLICATION_USER_POSTING = "page_user_posting";
export const PAGE_PUBLICATION_USERS = "page_my_users";
export const PAGE_PUBLICATION_EVENTS = "page_publication_events";
export const PAGE_PUBLICATION_CONTRACTS = "page_publication_contracts";
export const PAGE_COMMUNITY_ADVERTISERS = "page_community_advertisers";
export const PAGE_COMMUNITY_CREATORS = "page_community_creators";

export const PAGE_DESIGN_MARKETPLACE = "page_design_marketplace";
export const PAGE_DESIGN_MARKETPLACE_PUBLICATION_TEMPLATES =
  "page_design_marketplace_publication_templates";
export const PAGE_DESIGN_MARKETPLACE_THEMES = "page_design_marketplace_themes";
export const PAGE_DESIGN_MARKETPLACE_COMPONENTS =
  "page_design_marketplace_components";

export const PAGE_NETWORKS = "page_networks";
export const PAGE_ACTIVE_NETWORKS = "page_active_networks";
export const PAGE_MY_NETWORKS = "page_my_networks";

export const SIDE_NAV_COMMUNITY = [
  // {
  //   name: PAGE_COMMUNITY_COMMUNITY,
  //   label: "Home",
  //   actionValue: "/community",
  // },
  {
    name: PAGE_DIRECTORY,
    label: "Directory",
    actionValue: "/community/directory",
    icon: "address-book",
    subItems: [
      {
        name: PAGE_COMMUNITY_ADVERTISERS,
        label: "Advertisers",
        actionValue: "/community/directory/advertisers",
        icon: "display-chart-up-circle-dollar",
      },
      {
        name: PAGE_COMMUNITY_CREATORS,
        label: "Creators",
        actionValue: "/community/directory/creators",
        icon: "users",
      },
    ],
  },
  {
    name: PAGE_COMMUNITY_PUBLICATIONS,
    label: "Publications",
    actionValue: "/community/publications",
    icon: "newspaper",
  },
  {
    name: PAGE_COMMUNITY_PUBLICATION_COLLABORATION_ADS,
    label: "Collaboration Ads",
    actionValue: "/community/collaboration-ads",
    icon: "chart-user",
  },
  {
    name: PAGE_EXPERTS,
    label: "Experts",
    actionValue: "/community/experts",
    icon: "user-tag",
    subItems: [
      {
        name: PAGE_VIDEO_EDITORS,
        label: "Video Editors",
        actionValue: "/community/experts/video-editors",
        icon: "file-video",
      },
      {
        name: PAGE_SOCIAL_MEDIA_MANAGERS,
        label: "Social Media Managers",
        actionValue: "/community/experts/social-media-managers",
        icon: "hashtag",
      },
      {
        name: PAGE_CONTENT_CREATORS,
        label: "Content Creators",
        actionValue: "/community/experts/content-creators",
        icon: "video-camera-front",
      },
      {
        name: PAGE_GRAPHIC_DESIGNERS,
        label: "Graphic Designers",
        actionValue: "/community/experts/graphic-designers",
        icon: "palette",
      },
      {
        name: PAGE_MARKETING_STRATEGISTS,
        label: "Marketing Strategists",
        actionValue: "/community/experts/marketing-strategists",
        icon: "chart-line",
      },
    ],
  },
  {
    name: PAGE_MARKETPLACE,
    label: "Syndication Marketplace",
    actionValue: "/community/syndication-marketplace",
    icon: "store",
  },
  {
    name: PAGE_INVITES,
    label: "Refer a friend",
    actionValue: "/community/invites",
    icon: "user-plus",
  },
  {
    name: PAGE_REFER_AND_EARN,
    label: "Refer & Earn",
    actionValue: "/community/refer-and-earn",
    icon: "dollar",
  },
  {
    name: PAGE_DESIGN_MARKETPLACE,
    label: "Design Marketplace",
    actionValue: "/community/design-marketplace",
    icon: "brush",
    subItems: [
      {
        name: PAGE_DESIGN_MARKETPLACE_PUBLICATION_TEMPLATES,
        label: "Publication Templates",
        actionValue: "/community/design-marketplace/publication-templates",
        icon: "objects-column",
      },
      {
        name: PAGE_DESIGN_MARKETPLACE_THEMES,
        label: "Themes",
        actionValue: "/community/design-marketplace/themes",
        icon: "palette",
      },
      {
        name: PAGE_DESIGN_MARKETPLACE_COMPONENTS,
        label: "Components",
        actionValue: "/community/design-marketplace/components",
        icon: "send-backward",
      },
    ],
  },
  {
    name: PAGE_NETWORKS,
    label: "Networks",
    actionValue: "/community/networks",
    icon: "diagram-project",
    subItems: [
      {
        name: PAGE_ACTIVE_NETWORKS,
        label: "Browse all",
        actionValue: "/community/networks/active",
        icon: "network-wired",
      },
      {
        name: PAGE_MY_NETWORKS,
        label: "My Networks",
        actionValue: "/community/networks/my",
        icon: "users",
      },
    ],
  },
];

// /////////////////////////////////////
// Digital Wallet Section Page Names //
// /////////////////////////////////////

export const PAGE_DIGITAL_WALLET_DASHBOARD = "page_digital_wallet_dashboard";
export const PAGE_WITHDRAWAL_HISTORY = "page_digital_wallet_withdrawals";
export const PAGE_PENDING_EARNINGS = "page_digital_wallet_pending_earnings";
export const PAGE_INVOICES = "page_digital_wallet_invoices";
export const PAGE_WALLET_SETTINGS = "page_digital_wallet_settings";

export const SIDE_NAV_DIGITAL_WALLET = [
  {
    name: PAGE_DIGITAL_WALLET_DASHBOARD,
    label: "Digital Wallet",
    actionValue: "/digital-wallet/org/{org_id}",
  },
  {
    name: PAGE_WITHDRAWAL_HISTORY,
    label: "Withdrawals",
    actionValue: "/digital-wallet/org/{org_id}/withdrawals",
  },
  {
    name: PAGE_PENDING_EARNINGS,
    label: "Pending Earnings",
    actionValue: "/digital-wallet/org/{org_id}/pending-earnings",
  },
  {
    name: PAGE_INVOICES,
    label: "Invoices",
    actionValue: "/digital-wallet/org/{org_id}/invoices",
  },
  {
    name: PAGE_WALLET_SETTINGS,
    label: "Wallet Settings",
    actionValue: "/digital-wallet/org/{org_id}/settings",
  },
];

// //////////////////////////////
// Settings Section Page Names //
// //////////////////////////////

export const PAGE_SOCIAL_NETWORK_SETTINGS = "page_social_network_settings";
export const PAGE_COLLABORATOR_INVITATIONS_SETTINGS =
  "page_collaborator_invitations_settings";
export const PAGE_AFFILIATE_PLATFORM_SETTINGS =
  "page_affiliate_platform_settings";
export const PAGE_INFLUENCER_PLATFORM_SETTINGS =
  "page_influencer_platform_settings";
export const PAGE_USER_ACCOUNT_SETTINGS = "page_user_settings";
export const PAGE_ADVERTISING_SETTINGS = "page_advertising_settings";
export const PAGE_ORGANIZATION_SETTINGS = "page_org_settings";

export const SIDE_NAV_SETTINGS = [
  {
    name: PAGE_ORG_SETTINGS,
    label: "Company Settings",
    actionValue: "/settings/org/{org_id}",
    icon: "building",
  },
  {
    name: PAGE_USER_SETTINGS,
    label: "User Settings",
    actionValue: "/settings/user/{user_id}",
    icon: "user",
  },
  {
    name: PAGE_SOCIAL_NETWORK_SETTINGS,
    label: "Social Networks",
    actionValue: "/settings/org/{org_id}/social-networks",
    icon: "share-nodes",
  },
  {
    name: PAGE_MY_SERVICES,
    label: "My Services",
    actionValue: "/settings/org/{org_id}/my-services",
    icon: "list-check",
  },
  {
    name: PAGE_ADVERTISING_SETTINGS,
    label: "Advertising",
    actionValue: "/settings/org/{org_id}/advertising",
    icon: "rectangle-ad",
  },
  {
    name: PAGE_AFFILIATE_PLATFORM_SETTINGS,
    label: "Affiliate Platforms",
    actionValue: "/settings/org/{org_id}/affiliate-platforms",
    requiredCapabilities: [CAPABILITY_SUB_AFFILIATE_NETWORK],
    icon: "link",
  },
  {
    name: PAGE_USER_PUBLICATIONS,
    label: "Joined Publications",
    actionValue: "/settings/user/{user_id}/publications",
    icon: "newspaper",
  },
  // {
  //   name: PAGE_COLLABORATOR_INVITATIONS_SETTINGS,
  //   label: "Collaboration",
  //   actionValue: "/settings/org/{org_id}/invitations",
  //   requiredCapabilities: [CAPABILITY_PUBLICATIONS],
  //   icon: "user-group",
  // },
  // {
  //   name: PAGE_INFLUENCER_PLATFORM_SETTINGS,
  //   label: "Influencer Platforms",
  //   actionValue: "/settings/org/{org_id}/influencer-platforms",
  //   icon: "star",
  // },
];

// //////////////////////////////
// Billing Section Page Names //
// //////////////////////////////

export const PAGE_ACTIVE_SUBSCRIPTIONS = "page_active_subscriptions";
export const PAGE_CANCELLED_SUBSCRIPTIONS = "page_cancelled_subscriptions";
export const PAGE_BILLING_HISTORY = "page_billing_history";
export const PAGE_PURCHASED_DIGITAL_PRODUCTS =
  "page_purchased_digital_products";

export const SIDE_NAV_BILLING = [
  {
    name: PAGE_ACTIVE_SUBSCRIPTIONS,
    label: "Active Subscriptions",
    actionValue: "/billing/org/{org_id}/active",
    icon: "credit-card",
  },
  {
    name: PAGE_BILLING_HISTORY,
    label: "Billing History",
    actionValue: "/billing/org/{org_id}/history",
    icon: "clock-rotate-left",
  },
  {
    name: PAGE_CANCELLED_SUBSCRIPTIONS,
    label: "Cancelled Subscriptions",
    actionValue: "/billing/org/{org_id}/cancelled",
    icon: "ban",
  },
  {
    name: PAGE_PURCHASED_DIGITAL_PRODUCTS,
    label: "Purchased Digital Products",
    actionValue: "/billing/org/{org_id}/digital-products",
    icon: "box-open",
  },
];

export const PAGE_ONBOARDING_APPLY = "page_onboarding_apply";
export const PAGE_ONBOARDING_PENDING = "page_onboarding_pending";
export const PAGE_ONBOARDING_REJECTED = "page_onboarding_rejected";

export const SIDE_NAV_ONBOARDING = [
  {
    name: PAGE_ONBOARDING_APPLY,
    label: "Apply",
    actionValue: "/{org_id}/apply",
  },
];
export const SIDE_NAV_STYLE_OVERRIDES = {
  subMenuPaddingLeft: "extraLarge",
  negativeSubMenuPaddingRight: "extraLarge",
  menuItemMarginBottom: "extraSmall",
  menuItemHoverBackgroundColor: "light",
  // "menuItemActiveBackgroundColor": "striking",
  menuItemBorderRadius: "standard",
  menuItemPaddingLeft: "none",
};
